// extracted by mini-css-extract-plugin
export const root = "grid-row-module--root--16nas";
export const isFullscreen = "grid-row-module--isFullscreen--J2BmT";